import React from "react";
import BaseSelect from "../../BaseComponents/BaseSelect";
import MultiSelect from "../../BaseComponents/BaseSelect/MultiSelect";
import BaseRadioGroup from "../../BaseComponents/BaseRadio";
import { formFields, hrEnums } from "../../Constant/HR_Staff/hrEnums";
import { SelectPlaceHolder } from "../../Constant/validation";
import { RequiredSign } from "../../Constant/common";
import { ProfileSection, InfoField } from "../../BaseComponents/ProfileSection";
import { Settings } from "react-feather";

const GeneralDetails = ({
  staffForm,
  viewGeneralMode,
  handleGeneralEdit,
  handleGeneralDiscard,
  editGeneralMode,
  handleMulti,
  selectedMulti,
  holidayData,
  staffData,
  leaveData,
  shiftData,
  btnLoader,
  isProfile,
  overtimePolicyType,
}) => {
  const isSaveDisabled = React.useMemo(() => {
    const fields = [
      "week_off",
      "holiday_template",
      "leave_template",
      "shift",
      "salary_access",
      "attendance_mode",
      "is_applicable_for_overtime",
    ];

    return !fields.some((field) => {
      const val = staffForm.values[field];
      const initVal = staffForm.initialValues[field];

      if (Array.isArray(val) || Array.isArray(initVal)) {
        const valArr = Array.isArray(val) ? val : [];
        const initArr = Array.isArray(initVal) ? initVal : [];
        if (valArr.length !== initArr.length) return true;
        return valArr.some((item, idx) => item !== initArr[idx]);
      }

      const normalizedVal = val === null || val === undefined ? "" : String(val).trim();
      const normalizedInitVal =
        initVal === null || initVal === undefined ? "" : String(initVal).trim();
      return normalizedVal !== normalizedInitVal;
    });
  }, [staffForm.values, staffForm.initialValues]);

  return (
    <ProfileSection
      id="general-info"
      title={hrEnums.GENERAL_INFO}
      icon={Settings}
      iconColor="#8b5cf6"
      viewMode={viewGeneralMode}
      editMode={editGeneralMode}
      onEdit={handleGeneralEdit}
      onDiscard={handleGeneralDiscard}
      isEditable={!isProfile}
      btnLoader={btnLoader}
      animDelay="60ms"
      isSaveDisabled={isSaveDisabled}
    >
      {viewGeneralMode ? (
        <div className="row">
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.WEEK_OFF}
              value={
                staffData?.assignedWeekOff?.length
                  ? staffData.assignedWeekOff.map((w) => w.week_off).join(", ")
                  : null
              }
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.HOLIDAY_TEMPLATE}
              value={staffData?.staffGeneralInformation?.holiday?.template_name}
              required
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.LEAVE_TEMPLATE}
              value={staffData?.staffGeneralInformation?.leave?.leave_template_name}
              required
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.SHIFT}
              value={staffData?.staffGeneralInformation?.shift?.shift_name}
              required
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.SALARY_ACCESS}
              value={staffData?.staffGeneralInformation?.salary_access}
              required
            />
          </div>
          <div className="col-6 col-md-3">
            <InfoField
              label={hrEnums.ATTENDANCE_MODE}
              value={staffData?.staffGeneralInformation?.attendance_mode}
            />
          </div>
          {overtimePolicyType === "overtime_payment" && (
            <div className="col-6 col-md-3">
              <InfoField
                label={hrEnums.IS_APPLICABLE_FOR_OVERTIME}
                value={
                  staffData?.staffGeneralInformation?.is_applicable_for_overtime ? "Yes" : "No"
                }
              />
            </div>
          )}
        </div>
      ) : (
        <div className="row g-3">
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <MultiSelect
              id={formFields.week_off}
              name={formFields.week_off}
              label={hrEnums.WEEK_OFF}
              options={hrEnums.WEEK_OFF_OP}
              placeholder={SelectPlaceHolder(hrEnums.WEEK_OFF)}
              handleBlur={staffForm.handleBlur}
              onChange={handleMulti}
              value={selectedMulti ?? null}
              touched={staffForm.touched.week_off}
              error={staffForm.errors.week_off}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              id={formFields.holiday_template}
              name={formFields.holiday_template}
              label={
                <>
                  {hrEnums.HOLIDAY_TEMPLATE}
                  <span className="text-danger ms-1">{RequiredSign}</span>
                </>
              }
              options={holidayData}
              placeholder={SelectPlaceHolder(hrEnums.HOLIDAY_TEMPLATE)}
              handleChange={(f, v) => staffForm.setFieldValue(f, v)}
              handleBlur={() => staffForm.setFieldTouched(hrEnums.HOLIDAY_TEMPLATE, true)}
              value={staffForm.values.holiday_template}
              touched={staffForm.touched.holiday_template}
              error={staffForm.errors.holiday_template}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              id={formFields.leave_template}
              name={formFields.leave_template}
              label={
                <>
                  {hrEnums.LEAVE_TEMPLATE}
                  <span className="text-danger ms-1">{RequiredSign}</span>
                </>
              }
              options={leaveData}
              placeholder={SelectPlaceHolder(hrEnums.LEAVE_TEMPLATE)}
              handleChange={(f, v) => staffForm.setFieldValue(f, v)}
              handleBlur={() => staffForm.setFieldTouched(hrEnums.LEAVE_TEMPLATE, true)}
              value={staffForm.values.leave_template}
              touched={staffForm.touched.leave_template}
              error={staffForm.errors.leave_template}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              id={formFields.shift}
              name={formFields.shift}
              label={
                <>
                  {hrEnums.SHIFT}
                  <span className="text-danger ms-1">{RequiredSign}</span>
                </>
              }
              options={shiftData}
              placeholder={SelectPlaceHolder(hrEnums.SHIFT)}
              handleChange={(f, v) => staffForm.setFieldValue(f, v)}
              handleBlur={() => staffForm.setFieldTouched(hrEnums.SHIFT, true)}
              value={staffForm.values.shift}
              touched={staffForm.touched.shift}
              error={staffForm.errors.shift}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              id={formFields.salary_access}
              name={formFields.salary_access}
              label={
                <>
                  {hrEnums.SALARY_ACCESS}
                  <span className="text-danger ms-1">{RequiredSign}</span>
                </>
              }
              options={hrEnums.SALARY_ACCESS_OP}
              placeholder={SelectPlaceHolder(hrEnums.SALARY_ACCESS)}
              handleChange={(f, v) => staffForm.setFieldValue(f, v)}
              handleBlur={() => staffForm.setFieldTouched(hrEnums.SALARY_ACCESS, true)}
              value={staffForm.values.salary_access}
              touched={staffForm.touched.salary_access}
              error={staffForm.errors.salary_access}
              isDisabled={btnLoader}
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-12">
            <BaseSelect
              id={formFields.attendance_mode}
              name={formFields.attendance_mode}
              label={hrEnums.ATTENDANCE_MODE}
              options={hrEnums.ATTENDANCE_MODE_OP}
              placeholder={SelectPlaceHolder(hrEnums.ATTENDANCE_MODE)}
              handleChange={(f, v) => staffForm.setFieldValue(f, v)}
              handleBlur={() => staffForm.setFieldTouched(hrEnums.ATTENDANCE_MODE, true)}
              value={staffForm.values.attendance_mode}
              touched={staffForm.touched.attendance_mode}
              error={staffForm.errors.attendance_mode}
              isDisabled={btnLoader}
            />
          </div>
          {overtimePolicyType === "overtime_payment" && (
            <div className="col-xl-3 col-lg-3 col-md-6 col-12">
              <label className="form-label">{hrEnums.IS_APPLICABLE_FOR_OVERTIME}</label>
              <BaseRadioGroup
                name="is_applicable_for_overtime"
                options={hrEnums.IS_APPLICABLE_FOR_OVERTIME_OP}
                selectedValue={staffForm.values.is_applicable_for_overtime}
                onChange={(e) =>
                  staffForm.setFieldValue("is_applicable_for_overtime", e.target.value)
                }
                value={staffForm.values.is_applicable_for_overtime}
                touched={staffForm.touched.is_applicable_for_overtime}
                error={staffForm.errors.is_applicable_for_overtime}
                handleBlur={staffForm.handleBlur}
                disabled={btnLoader}
                inline={true}
              />
            </div>
          )}
        </div>
      )}
    </ProfileSection>
  );
};

export default GeneralDetails;
